export const EDITION_AWARENESS = 'EditionAwareness';
export const PACKAGE_NAME = 'jiraNavigationAppsSidebarEditionAwareness';
